import { EventValidationErrorEnum } from "../graphql/schema/types";

export const PUBLISH_ERROR_I18N_KEYS: Record<EventValidationErrorEnum, string> =
  {
    [EventValidationErrorEnum.MissingTitle]:
      "events.publishErrors.MISSING_TITLE",
    [EventValidationErrorEnum.TitleTooShort]:
      "events.publishErrors.TITLE_TOO_SHORT",
    [EventValidationErrorEnum.TitleTooLong]:
      "events.publishErrors.TITLE_TOO_LONG",
    [EventValidationErrorEnum.MissingType]: "events.publishErrors.MISSING_TYPE",
    [EventValidationErrorEnum.MissingCategory]:
      "events.publishErrors.MISSING_CATEGORY",
    [EventValidationErrorEnum.MissingDescription]:
      "events.publishErrors.MISSING_DESCRIPTION",
    [EventValidationErrorEnum.DescriptionTooShort]:
      "events.publishErrors.DESCRIPTION_TOO_SHORT",
    [EventValidationErrorEnum.RecurringConfigError]:
      "events.publishErrors.RECURRING_CONFIG_ERROR",
    [EventValidationErrorEnum.EventStartDateError]:
      "events.publishErrors.EVENT_START_DATE_ERROR",
    [EventValidationErrorEnum.MissingPlace]:
      "events.publishErrors.MISSING_PLACE",
    [EventValidationErrorEnum.MissingPlatform]:
      "events.publishErrors.MISSING_PLATFORM",
    [EventValidationErrorEnum.MainImageMissing]:
      "events.publishErrors.MAIN_IMAGE_MISSING",
    [EventValidationErrorEnum.NoTickets]: "events.publishErrors.NO_TICKETS",
    [EventValidationErrorEnum.StripeRestricted]:
      "events.publishErrors.STRIPE_RESTRICTED",
    [EventValidationErrorEnum.PaymentConfigEmpty]:
      "events.publishErrors.PAYMENT_CONFIG_EMPTY",
    [EventValidationErrorEnum.StripeAccountNotSubmitted]:
      "events.publishErrors.STRIPE_ACCOUNT_NOT_SUBMITTED",
    [EventValidationErrorEnum.PaymentConfigError]:
      "events.publishErrors.PAYMENT_CONFIG_ERROR",
    [EventValidationErrorEnum.BankAccountInfoMissing]:
      "events.publishErrors.BANK_ACCOUNT_INFO_MISSING",
  } as const;
